<template>
  <a-modal v-model="visible" :width="scene === WAREHOUSETYPE.out ? '1300px': '1100px'" title="请选择货品" :destroy-on-close="true" :footer="null" centered @ok="confirm">
    <div class="chooseGoods"></div>
    <a-form-model :model="form" :rules="rules" layout="inline">
      <a-form-model-item ref="skuCode" :colon="false" label="货主货品编码" prop="skuCode">
        <a-input v-model="form.skuCode" placeholder="请输入" @pressEnter="searchList" />
      </a-form-model-item>
      <a-form-model-item ref="skuName" :colon="false" label="货品名称" prop="skuName">
        <a-input v-model="form.skuName" placeholder="请输入" @pressEnter="searchList" />
      </a-form-model-item>
      <a-form-model-item v-if="temperatureLayer === '全部'" ref="temperatureZone" :colon="false" label="温区" prop="temperatureZone">
        <a-select
          v-model="form.temperatureZone"
          style="width: 120px"
          :get-popup-container="triggerNode => triggerNode.parentNode"
        >
          <a-select-option
            v-for="(temp, i) in TEMPERATURES"
            :key="i"
            :value="temp.value"
          >{{temp.label}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- <a-form-model-item
        v-if="scene === WAREHOUSETYPE.out"
      >
        <a-input-group compact>
          <a-select
            v-model="batchOption.option"
            style="width: 100px;"
            :get-popup-container="triggerNode => triggerNode.parentNode"
          >
            <a-select-option
              v-for="item in BATCHLIST"
              :key="item.value"
              :value="item.value"
            >
              {{item.label}}
            </a-select-option>
          </a-select>
          <a-input
            v-model="batchOption.value"
            placeholder="请输入"
            style="width: 120px;"
            @pressEnter="searchList"
          />
        </a-input-group>
      </a-form-model-item> -->
      <a-form-model-item ref="goodsLevel" :colon="false" label="货品三级分类" prop="goodsLevel">
        <a-cascader
          v-model="form.goodsLevel"
          change-on-select
          :options="goodsLevelOptions"
          :field-names="{
            label: 'name',
            value: 'name',
            children: 'children'
          }"
          placeholder="请选择"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button class="goodsSelectStyle" type="primary" @click="searchList">查询</a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="tips">
      <span>最多选择50个货品</span>
    </div>
    <div class="tablebox">
      <a-table
        :columns="goodsTableListColumns"
        :data-source="goodsAllList"
        :pagination="pagination"
        class="goods-table table-sigle"
        :custom-row="onclickRow"
        :row-key="record => `${record.code}`"
        :scroll="{ x: 'calc(800px + 50%)', y: '40vh'}"
        :row-selection="{
          onSelect,onSelectAll,
          onChange,
          selectedRowKeys: selectedRowKeys,
          getCheckboxProps
      }"
        @change="tableChange"
      >
        <template v-for="col in ['skuCode', 'norms']" :slot="col" slot-scope="text">
          <a-tooltip :key="col" placement="top">
            {{ text }}
            <template slot="title">{{ text }}</template>
          </a-tooltip>
        </template>
        <template slot="skuName" slot-scope="text, rowData">
          <a-tooltip placement="top">
            <span v-if="proving(rowData, UsageStatus.RECENTUSE, 'latestUsed')" class="latelyStyle">最近使用</span>
            <span v-if="proving(rowData, UsageStatus.COMMONLY_USED, 'usualUsed')" class="oftenStyle">常用</span>
            {{ text }}
            <template slot="title">{{ text }}</template>
          </a-tooltip>
        </template>
        <template slot="goodsPrice" slot-scope="text">
          {{ text !== '' && text !== null ? `${text}.00` : ''}}
        </template>
        <template slot="volumeOut" slot-scope="text">
          {{text.toFixed(3)}}
        </template>
      </a-table>
    </div>
    <a-row>
      <a-col :span="12">
        <!-- <p :class="goodsAllList.length > 0 ? 'addTips activeStyle' :'addTips'">
          <span>没有想要的货品？</span>
          <span @click="toAddGoods">新建货品</span>
        </p> -->
      </a-col>
        <a-col :span="12">
            <a-button class="boxBtn" type="primary" @click="yesSelect">选好了</a-button>
            <a-button class="boxBtn" @click="confirm">取消</a-button>
        </a-col>
    </a-row>
    <AddGoods ref="addGoods" @create="searchList"></AddGoods>
  </a-modal>
</template>

<script>
import BigNumber from 'bignumber.js'
import { goodsTableListColumns, goodsTableListColumnsOut } from "../goodsTable";
import AddGoods from './AddGoods'
import { shipperGoods, warehouseGoods, getLevelTree } from '../api'
import { WAREHOUSETYPE } from '../constant'
import {getConfig} from '../../../orderManage/api'

const UsageStatus = {
  RECENTUSE: 1,
  COMMONLY_USED: 1
}

const TEMPERATURES = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "常温",
    label: "常温（环境温度）",
  },
  {
    value: "冷藏",
    label: "冷藏（0°C〜6°C）",
  },
  {
    value: "冷冻",
    label: "冷冻（-18°C以下）",
  },
  {
    value: "恒温",
    label: "恒温（15°C〜20°C）",
  },
];
const MAX_GOODS_NUMBER = 50;
const tempList = [
  {
    key: 'NORMAL',
    value: '常温'
  },
  {
    key: 'REFRIGERATE',
    value: '冷藏'
  },
  {
    key: 'COLD',
    value: '冷冻'
  },
  {
    key: 'CONSTANT',
    value: '恒温'
  },
]


export default {
  name: "ChooseGoods",
  components: {
      AddGoods
  },
  props: {},
  data() {
    return {
      UsageStatus,
      visible: false,
      pageSize: 10,
      goodsAllList: [],
      CustomerCodeAuth:[],
      form: {
        skuCode: null,
        skuName: null,
        temperatureZone: "",
        goodsLevel: [],
      },
      rules: {
        skuCode: [],
      },
      TEMPERATURES,
      WAREHOUSETYPE,
      // BATCHLIST,
      // batchOption: {
      //   option: BATCHLIST[0].value,
      // },
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {(this.pageSize = pageSize)},
        showQuickJumper: true,
        showTotal: (total) => `已选${this.selectedRowKeys.length}条 共 ${total} 条`,
      },
      selectedRows: [],
      selectedRowKeys: [],
      scene: WAREHOUSETYPE.in,
      deliverWarehouseCode: '',
      deliverWarehouseId: '',
      shipperCode: '',
      goodsLevelOptions: [],
      temperatureLayer:'' // 外面传过来的温区
    };
  },
  computed: {
    goodsTableListColumns(){
      const outTableColumns=this.isExistAuthList?goodsTableListColumnsOut.filter(item=> item.key!=='batchNo'):goodsTableListColumnsOut
      return this.scene === WAREHOUSETYPE.in ? goodsTableListColumns :outTableColumns
    },
  },
 async created() {
    this.customerCode=this.$store.state.user.customerCode
     await this.init();

  },
  mounted() {},
  methods: {
    init() {
      // this.setGoodsCategory();
      this.setCustomerCodeAuth()
      this.getLevelOption()
    },
    async getLevelOption() {
      this.goodsLevelOptions = await getLevelTree()
    },
    async setCustomerCodeAuth() {
       const params = {
        keys: ['oms.order.check.stock.customer'],
      };
      const res = await getConfig(params);
      this.CustomerCodeAuth=res.configs[0].value.split(',')
      this.isExistAuthList=this.CustomerCodeAuth.includes(this.customerCode)
    },
    filterData(data, value){
      return data === value ? null : data
    },
    filterTemperature(val) {
      if (val) {
        return tempList.filter(item => item.value === val)[0]?.key || null
      }
      return null
    },
    proving(rowData, type, name) {
      if (name === 'usualUsed' && rowData.ext && rowData.ext.usualUsed && rowData.ext.usualUsed === type ) {
        return true
      }
      if (name === 'latestUsed' && rowData.ext && rowData.ext.latestUsed && rowData.ext.latestUsed === type ) {
        return true
      }
      return false
    },
    searchList(){
      this.pagination.current = 1;
      this.getList()
    },
    getList() {
      const params = {
        size: this.pageSize,
        page: this.pagination.current
      }
      if(this.scene === WAREHOUSETYPE.in){
        let temperatureLayer = ''
        tempList.forEach((e) => {
          if(e.value === this.filterData(this.form.temperatureZone, '')){
            temperatureLayer = e.key
          }
        })
        const data = {
          status: 'ENABLED',
          deleteStatus: 0,
          // bizType: 'TRANSPORT_WAREHOUSE',
          warehouseCode: this.deliverWarehouseCode, // 仓库id
          shipperCode: this.shipperCode, // 货主编号
          goodsName: this.filterData(this.form.skuName, ''),
          goodsCode: this.filterData(this.form.skuCode, ''),
          temperatureLayer,
          goodsLevel1: this.form.goodsLevel[0] || null,
          goodsLevel2: this.form.goodsLevel[1] || null,
          goodsLevel3: this.form.goodsLevel[2] || null,
        }
        warehouseGoods(data, params).then((res) => {
          this.goodsAllList = res.records.map((e) => {
            const volume = (e.goodsLength * e.goodsWide * e.goodsHeight) / 1000000
            return {
              ...e,
              id: null,
              skuId: e.id || e.skuId,
              code: e.id,
              singleVolume: e.volume || 0,
              singleWeight: e.weight || 0,
              skuCode: e.shipperGoodsCode,
              skuName: e.goodsName,
              norms: e.goodsSpecifications,
              temperatureZone: e.temperatureLayerName,
              wholeUnit: `${e.bigUnit}/${e.smallUnit}*${e.conversionRate}`,
              volume: volume.toFixed(3),
            }
          })
          this.pagination.total = res.total
        })
      }
      if(this.scene === WAREHOUSETYPE.out){
        // const {batchOption} = this
        const data = {
          // tenantId: this.deliverWarehouseCode, // 仓库id
          warehouseCode: this.deliverWarehouseCode,       // 货主编号
          goodsTemperatureLayer: this.filterTemperature(this.form.temperatureZone),
          goodsName: this.filterData(this.form.skuName, ''),
          customerIds: [this.deliverWarehouseId],
          goodsCode: this.filterData(this.form.skuCode, ''),
          // status: 1,
          // deleteStatus: 0,
          goodsLevel1: this.form.goodsLevel[0] || null,
          goodsLevel2: this.form.goodsLevel[1] || null,
          goodsLevel3: this.form.goodsLevel[2] || null,
          // batchFields: [
          //   {
          //     fieldCode: batchOption.option,
          //     fieldValue: batchOption.value
          //   }
          // ]
        }
        shipperGoods(data, params).then((res) => {
          this.goodsAllList = res.records.map((e) => {
            const volume = BigNumber(e.singleVolume)
            return {
              ...e,
              id: null,
              code: e.shipperGoodsCode,
              // skuCode: e.shipperGoodsCode,
              // norms: e.goodsSpecifications,
              // skuName: e.goodsName,
              singleVolume:volume.div(1000000).toNumber(),
              temperatureZone: e.temperatureLayerName,
              wholeUnit: `一${e.bigUnit || '件'}=${e.conversionRate || 1}${e.smallUnit|| '件'}`,
              goodsLevel: `${e.goodsLevel1 || ''}/${e.goodsLevel2 || ''}/${e.goodsLevel3 || ''}`
            }
          })
          this.pagination.total = res.total
        })
      }
       if(this.scene === WAREHOUSETYPE.inventory){
        // const {batchOption} = this
        const data = {
          // tenantId: this.deliverWarehouseCode, // 仓库id
          warehouseCode: this.deliverWarehouseCode,       // 货主编号
          goodsTemperatureLayer: this.filterTemperature(this.form.temperatureZone),
          goodsName: this.filterData(this.form.skuName, ''),
          customerIds: [this.deliverWarehouseId],
          goodsCode: this.filterData(this.form.skuCode, ''),
          // status: 1,
          // deleteStatus: 0,
          goodsLevel1: this.form.goodsLevel[0] || null,
          goodsLevel2: this.form.goodsLevel[1] || null,
          goodsLevel3: this.form.goodsLevel[2] || null,
          // batchFields: [
          //   {
          //     fieldCode: batchOption.option,
          //     fieldValue: batchOption.value
          //   }
          // ]
        }
        shipperGoods(data, params).then((res) => {
          this.goodsAllList = res.records.map((e) => {
            const volume = BigNumber(e.singleVolume)
            return {
              ...e,
              id: null,
              code:  e.skuId||e.goodsId,
              // skuCode: e.shipperGoodsCode,
              // norms: e.goodsSpecifications,
              // skuName: e.goodsName,
              singleVolume:volume.div(1000000).toNumber(),
              temperatureZone: e.temperatureLayerName,
              wholeUnit: `一${e.bigUnit || '件'}=${e.conversionRate || 1}${e.smallUnit|| '件'}`,
              goodsLevel: `${e.goodsLevel1 || ''}/${e.goodsLevel2 || ''}/${e.goodsLevel3 || ''}`
            }
          })
          this.pagination.total = res.total
        })
      }
    },
    yesSelect() {
      const arr = []
      this.selectedRows.forEach((e) => {
        this.selectedRowKeys.forEach((res)=>{
          if (res === `${e.code}`) {
            arr.push(e)
          }
        })
      })
      this.$emit('change', arr)
      this.confirm()
    },
    confirm() {
      this.visible = false;
      this.form.skuCode = null;
      this.form.skuName = null;
      this.form.temperatureZone = "";
      this.form.goodsLevel = [];
      // this.batchOption = {
      //   option: BATCHLIST[0].value,
      // }
      this.pageSize = 10;
      this.pagination.current = 1;
    },
    show(goods, scene, code, shipperCode, warehouseId, temperatureLayer = '全部') {
      this.deliverWarehouseCode = code
      this.shipperCode = shipperCode
      this.deliverWarehouseId = warehouseId
      this.scene = scene
      this.confirm()
      this.visible = true;
      this.pagination.current = 1;
      this.temperatureLayer = temperatureLayer
      this.form.temperatureZone = temperatureLayer
      this.getList();
      const keyArry = [];
      goods.forEach((e) => {
        keyArry.push(`${e.skuId}${e.stockBatch ? e.stockBatch : ''}`);
      })
      this.selectedRowKeys = keyArry;
      this.selectedRows = goods.map(e => {
        const res = e.skuNorms?.split('/') || []
        return {
          ...e,
          code: `${e.skuId}${e.stockBatch ? e.stockBatch : ''}`,
          norms: res[0],
          // goodsPrice: e.goodsValue,
        };
      })
    },
    onclickRow(record) {
      return {
        on: {
            click: () => {
              if(record.stockNum === 0){
                return
              }
              if (!this.selectedRowKeys.includes(`${record.code}`)) {
                this.selectedRowKeys.push(`${record.code  }`)
                this.selectedRows.push(record)
              } else {
                const index = this.selectedRowKeys.indexOf(`${record.code}`)
                this.selectedRowKeys.splice(index, 1)
                this.selectedRows.splice(index, 1)
              }
            }
        }
      }
    },
    onSelect(record, selected) {
      if (selected) {
        const goodsNumber = this.selectedRows.length
        if (goodsNumber >= MAX_GOODS_NUMBER) {
          this.$message({ type: "info", message: "最多可选择50个货品" });
        } else {
          this.selectedRows.push(record)
        }
      }
      if (!selected) {
        this.remove(record)
      }
    },
    getCheckboxProps(record){
      return {
        props: {
          disabled: record.stockNum === 0,
          name: record.name,
        }
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        const goodsNumber = this.selectedRows.length + changeRows.length
        if (goodsNumber > MAX_GOODS_NUMBER) {
          this.$message({ type: "info", message: "最多可选择50个货品" });
        } else {
          this.selectedRows.push(...changeRows)
        }
      }
      if (!selected) {
        changeRows.forEach((e) => {
          this.remove(e)
        })
      }
    },
    onChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys
    },
    remove(record) {
      this.selectedRows = this.selectedRows.filter((e) => {
        return e.code !== record.code
      })
    },
    toAddGoods() {
        this.$refs.addGoods.show()
    },
    toBatch() {
        this.$router.push({
          path: '/order/create-multiple'
        })
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList()
    },
  },
};
</script>

<style lang="less" scoped>
.icon_load {
  width: 24px;
  height: 24px;
}
.tips {
  font-size: 12px;
  color: red;
  margin: 5px 0 10px;
  .link {
    text-decoration: underline;
    color: #adadad;
    cursor: pointer;
  }
}
.tablebox {
  max-height: 60vh;
  overflow-y: scroll;
  margin-bottom: 10px;
  position: relative;
  /deep/ .ant-table{
      font-size: 12px !important;
      .ant-table-thead ,.ant-table-scroll{
          background-color: #f5f5f5;
      }
      .ant-table-column-title{
        font-weight: bold;
      }
  }
}
.addTips {
    // position: absolute;
    // left: 0;
    // bottom: 22px;
    font-size: 14px;
    color: #aaaaaa;
    span:last-child {
      color: #06b880;
      text-decoration: underline;
      &:hover {
        cursor: pointer;
      }
    }
  }
.latelyStyle {
  display: inline-block;
  margin-right: 5px;
  padding: 0 5px;
  border: 1px solid red;
  color: red;
  font-size: 12px;
  border-radius: 5px;
}
.oftenStyle {
  display: inline-block;
  margin-right: 5px;
  padding: 0 5px;
  border: 1px solid #1890ff;
  color: #1890ff;
  font-size: 12px;
  border-radius: 5px;
}
.boxBtn{
    float: right;
    margin-left: 20px;
}
.activeStyle{
  position:absolute;
  top: -43px;
  left: 0;
}
/deep/ .ant-table-row{
  &:hover{
    cursor: pointer;
  }
}
</style>
